/*
 * Copyright 2026 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Entity } from '@backstage/catalog-model';

export const isTableEntity = (entity: Entity) =>
  entity.kind.toLocaleLowerCase('en-US') === 'resource' &&
  entity.spec?.type === 'table';

const tableEntityRefPattern = /^resource:[^/]+\/(ch|pg)\./;

export const hasTableRelations = (entity: Entity) =>
  ['component', 'system'].includes(entity.kind.toLocaleLowerCase('en-US')) &&
  (entity.relations ?? []).some(relation =>
    tableEntityRefPattern.test(relation.targetRef),
  );

export const isDatabaseResource = (entity: Entity) =>
  entity.kind.toLocaleLowerCase('en-US') === 'resource' &&
  entity.spec?.type === 'database';

export const hasTables = (entity: Entity) =>
  hasTableRelations(entity) || isDatabaseResource(entity);
